import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {ReplaySubject} from "rxjs";
import {FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {validIban} from "../../../../shared/validator/iban-validator";
import {FormHelperService} from "../../../../shared/services/form-helper.service";
import {OfwcaService} from "../../../../shared/services/ofwca.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {HttpErrorResponse} from "@angular/common/http";
import {delay, takeUntil} from "rxjs/operators";
import {Ofwca} from "../../../../shared/interface/ofwca";
import {ReceivablesBalanceService} from "../../../../shared/services/receivables-balance.service";
import {co} from "@fullcalendar/core/internal-common";

@Component({
  selector: 'app-receivables-balance-add-dialog',
  templateUrl: './receivables-balance-add-dialog.component.html',
  styleUrls: ['./receivables-balance-add-dialog.component.scss']
})
export class ReceivablesBalanceAddDialogComponent implements OnInit, OnDestroy {

  receivablesBalanceAddForm: FormGroup;
  ofwcaControl: FormControl;
  partnerControl: FormControl;
  partnerFacilityControl: FormControl;
  enableSaveButton = false;
  processingRequest = false;
  formErrors: any = {};
  partnerOfwcaId = null;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    public dialogRef: MatDialogRef<ReceivablesBalanceAddDialogComponent>,
    private fb: FormBuilder,
    private formHelper: FormHelperService,
    private receivablesBalanceService: ReceivablesBalanceService,
    private ofwcaService: OfwcaService,
    private snack: MatSnackBar,
  ) {
    this.receivablesBalanceAddForm = fb.group({
      ofwca: this.ofwcaControl = fb.control(''),
      partner: this.partnerControl = fb.control(''),
      partnerFacility: this.partnerFacilityControl = fb.control('')
    },
      {
        validators: [this.atLeastOneRequiredValidator()]
      }
    );
  }

  atLeastOneRequiredValidator(): ValidatorFn {
    return (group: FormGroup): ValidationErrors | null => {
      const { ofwca, partner, partnerFacility } = group.value;

      return (ofwca || partner || partnerFacility) ? null : { atLeastOneRequired: true };
    };
  }

  ngOnInit(): void {
    this.ofwcaControl.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe(data => {
        if (data) {
          this.ofwcaService.get(data).subscribe(ofwca => {
            this.partnerOfwcaId = ofwca?.partner?.uuid;
          });
          this.partnerFacilityControl.reset();
        }
      });

    this.partnerControl.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe(data => {
        if (data) {
          this.ofwcaControl.reset();
          this.partnerFacilityControl.reset();
        }
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
  closeDialog(e): void {
    this.dialogRef.close(e);
  }

  sendForm(): void {
    if ( !this.receivablesBalanceAddForm.valid)
    {
      this.receivablesBalanceAddForm.markAllAsTouched();
      this.snack.open('Wypełnij lub popraw wszystkie wymagane pola', '', {
        duration: 2000,
      });
      return;
    }
    this.processingRequest = true;

    this.formErrors = {};

    this.receivablesBalanceService.send(this.receivablesBalanceAddForm.value)
      .subscribe(() => {
        this.snack.open('Pomyślnie dodano saldo', '', {
          duration: 2000,
        });
        this.processingRequest = false;
        this.dialogRef.close();
      }, (error: HttpErrorResponse) => {
        this.processingRequest = false;
        this.snack.open('Podczas dodawania salda wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });
        if (error.status === 400) {
          this.formErrors = error.error.error.list;
          this.formHelper.setBackendErrorState(this.receivablesBalanceAddForm, this.formErrors);
        }


      })
    ;
  }

}
